<div class="container-fluid">
  <div class="card border-light shadow-sm">
    <div class="row">
      <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
      </div>
      <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
        <h6>
          <span style="padding-right:5px"></span>
          <i class="fa fa-globe"></i>
          <b>Timetable For : </b>{{ dataCntrl?.application?.route_summary}}
        </h6>
      </div>
    </div>
  <div class="col-md-12">
    

    <!-- <form [formGroup]="formTimeTable"> -->
      <div class="col-md-12 p-0" id="test2">
        <div class="col-sm-12 p-0" >          
            <ckeditor [(ngModel)]="timeTableDetail"></ckeditor>        
        </div>
      </div>
    <!-- </form> -->

    </div>
    <div class="col-12" *ngIf="dataCntrl.status != 2 && !isApproval">
      <button class="btn btn-md m-clr pull-right hd-btn mt-2 ml-2"  (click)="backToTab()" title="Back"  style="float: left !important;">Back</button>
      <ng-container *ngIf="isProcess">
        <button class="btn btn-md m-clr pull-right hd-btn mt-2"  (click)="cancelApplication()" title="Cancel"  style="float: right !important;">Cancel</button>
        <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveTable()" title="Save & Continueto step 4"  style="float: right !important;" >Save & Continue</button>
      </ng-container>
    </div>
    <div *ngIf="isApproval" class="col-12">
      <button class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2" (click)="saveTable()" title="Update Time-Table"  style="float: right !important;" >Update Time-Table</button>
      
    </div>
  </div>
</div>

